<template>
	<div class="channel-bussi">
		<border-view>
			<div class="view-search"
				style="padding-top: 24px;height:150px;align-items: flex-end;flex-direction: column;">
				<FromComm :FromArr="FromArr" @selectChange="selectChange"
					@remoteMethod="(e)=>getCustomerList(e.qurey)" />
				<CommonBtngroup class="btngroup" style="margin-bottom: 24px;" :qhide="false" @select="handSearch('')"
					@reset="handReset('')" />
			</div>
			<!--金额展示部分-->
			<div class="view-amount">
				<div class="amount-label">
					渠道商业销售汇总（不含税）
				</div>
				<div class="amount-value">
					{{dataInfo?dataInfo.TotalString:0}}
				</div>
				<div class="amount-unit">
					单位:GTS
				</div>
			</div>
			<!-- 图表 -->
			<company-business v-if="dataInfo&&dataInfo.summaryReport" :info="dataInfo.summaryReport" />
		</border-view>

		<border-view title="渠道商业历史销量">
			<div class="view-search"
				style="padding-top: 24px;height:150px;align-items: flex-end;flex-direction: column;">
				<FromComm :FromArr="FromArr2" @selectChange="selectChange2"
					@remoteMethod="(e)=>getCustomerList2(e.qurey)" />
				<CommonBtngroup class="btngroup" style="margin-bottom: 24px;" :qhide="false" @select="handSearch('2')"
					@reset="handReset('2')" />
			</div>
			<div class="view-switch-list">
				<div class="view-switch">
					<div class="switch-item-red" v-for="(item,index) in switchYeItems" :key="index"
						:class="[yearIndex===index?'current-red':'']" @click="switchChange(index,'year')">
						{{item}}
					</div>
				</div>
			</div>
			<!-- 图表 -->
			<company-year v-if="dataInfo2" :info="dataInfo2" :type="yearIndex" />
		</border-view>

		<border-view title="渠道销量趋势图">
			<div class="view-search" style="padding-top: 24px;min-height: 210px;">
				<FromComm :FromArr="FromArr3" @selectChange="selectChange3"
					@remoteMethod="(e)=>getCustomerList3(e.qurey)" />
				<CommonBtngroup class="btngroup" style="min-width:180px;" :qhide="false" @select="handSearch('3')"
					@reset="handReset('3')" />
			</div>
			<div class="view-switch-list">
				<div class="view-switch" style="margin-right:48px;">
					<div class="switch-item-red" v-for="(item,index) in switchYeItems" :key="index"
						:class="[l3Index===index?'current-red':'']" @click="switchChange(index,'l3')">
						{{item}}
					</div>
				</div>
				<div class="view-switch">
					<div class="switch-item-blue" v-for="(item,index) in switchSJItems" :key="index"
						:class="[sjIndex===index?'current-blue':'']" @click="switchChange(index,'sj')">
						{{item}}
					</div>
				</div>
			</div>
			<!-- 图表 -->
			<company-trend v-if="dataInfo3&&sjIndex===0" :info="dataInfo3" :type="l3Index" />
			<!-- 图表 -->
			<company-money v-if="dataInfo3&&sjIndex===1" :info="dataInfo3" :type="l3Index" />
		</border-view>

		<border-view title="省份排名">
			<div class="view-search" style="padding-top: 24px;min-height: 130px;">
				<FromComm :FromArr="FromArr4" />
				<CommonBtngroup class="btngroup" style="min-width:180px;" :qhide="false" @select="handSearch('4')"
					@reset="handReset('4')" />
			</div>
			<div class="view-table">
				<el-table :data="dataInfo4" style="width: 100%" height="500">
					<el-table-column v-for="(item,index) in tableHead" :key="index" :label="item.label"
						:width="item.width" :fixed="item.fixed">
						<template slot-scope="scope">
							{{parseStr(scope.row[item.key],item.key)}}{{item.unit?item.unit:''}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</border-view>
	</div>
</template>

<script>
	import {
		GetHelperLevel1,
		GetHelperLevel3,
		GetSMSReportCustomerBusinessSummary,
		GetSMSReportCustomerBusinessAmount,
		GetSMSReportCustomerBusinessTendency,
		GetHelperAreaMan,
		GetHelperRegionMan,
		GetHelperSalesMan,
		GetProvinceSalesAmount,
		GetCustomerList,
		ProvinceASNRanking
	} from '@/api/newsapi'

	import {
		InventoryClassList,
	} from '@/api/home'

	import companyBusiness from './charts/company-business.vue';
	import hospTable from './charts/hosp-table.vue';
	import companyYear from './charts/company-year.vue';
	import companyTrend from './charts/company-trend.vue';
	import companyMoney from './charts/company-money.vue';
	import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import borderView from './border-view.vue';
	import {
		FromArr,
		FromArr2,
		FromArr3,
		FromArr4,
		tableHead
	} from '../FormData/channelBussi';
	export default {
		components: {
			companyBusiness,
			hospTable,
			FromComm,
			CommonBtngroup,
			companyYear,
			companyTrend,
			companyMoney,
			borderView
		},
		data() {
			return {
				FromArr: [],
				FromArr2: [],
				FromArr3: [],
				FromArr4: [],
				switchYeItems: ['月度', '季度', '年度'],
				yearIndex: 1,
				switchSJItems: ['数量', '金额'],
				sjIndex: 0, //数量金额
				l3Index: 1,
				query: {},
				dataInfo: null,
				query2: {},
				dataInfo2: null,
				query3: {},
				dataInfo3: null,
				query4: {},
				dataInfo4: null,
				tableHead: [],
			}
		},
		created() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArr2 = JSON.parse(JSON.stringify(FromArr2))
			this.FromArr3 = JSON.parse(JSON.stringify(FromArr3))
			this.FromArr4 = JSON.parse(JSON.stringify(FromArr4))
			this.tableHead = JSON.parse(JSON.stringify(tableHead));
			this.getHelperLevel1();
			this.getHelperLevel3();
			this.getSMSReportCustomerBusinessSummary();
			this.getSMSReportCustomerBusinessAmount();
			this.getSMSReportCustomerBusinessTendency();
			this.getProvinceSalesAmount();
			this.getInnerQuotaDetail();
			this.GetInvClass();
		},
		methods: {
			// 产品线
			async GetInvClass() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr4[1].options = [{
						key: '',
						value: '不限',
					}]
					data.data.map((item, index) => {
						this.FromArr4[1].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
			//获取l1数据
			async getHelperLevel1() {
				let {
					code,
					data
				} = await GetHelperLevel1({})
				if (code == 0) {
					this.FromArr[0].options = [{
						key: '不限',
						value: '',
					}]
					this.FromArr2[0].options = [{
						key: '不限',
						value: '',
					}]
					this.FromArr3[0].options = [{
						key: '不限',
						value: '',
					}]
					data.map((item, index) => {
						let obj = {
							key: item.value,
							value: item.key
						}
						this.FromArr[0].options.push(obj);
						this.FromArr2[0].options.push(obj);
						this.FromArr3[0].options.push(obj);
					})
				}
			}, //获取l3数据
			async getHelperLevel3(l1 = '') {
				let params = {};
				if (l1) {
					params.LEVEL1 = l1;
				}
				let {
					code,
					data
				} = await GetHelperLevel3(params);

				if (code == 0) {
					if (!l1) {
						this.FromArr2[1].options = [];
					}
					this.FromArr3[1].options = [];
					this.FromArr4[2].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.value,
							value: item.key
						}
						if (!l1) {
							this.FromArr2[1].options.push(obj);
						}
						this.FromArr3[1].options.push(obj);
						this.FromArr4[2].options.push(obj);
					})
				}
			},
			// 渠道商业汇总数据 
			async getSMSReportCustomerBusinessSummary() {
				let {
					code,
					data
				} = await GetSMSReportCustomerBusinessSummary(this.query);

				if (code == 0) {
					this.dataInfo = data;
				}
			},
			//渠道商业历年销量
			async getSMSReportCustomerBusinessAmount(e = {}) {
				let params = {};
				params.ByQuarter = this.yearIndex;
				params = Object.assign({}, params, e, this.query2);

				let {
					code,
					data
				} = await GetSMSReportCustomerBusinessAmount(params);

				if (code == 0) {
					this.dataInfo2 = data.salesAmountReport;
				}
			}, // L3商业销量趋势图
			async getSMSReportCustomerBusinessTendency(e = {}) {
				let params = {};
				params.ByQuarter = this.l3Index;
				params = Object.assign({}, params, e, this.query3);

				let {
					code,
					data
				} = await GetSMSReportCustomerBusinessTendency(params);

				if (code == 0) {
					this.dataInfo3 = data.tendencyReport;
				}
			},
			//获取大区经理
			async getHelperAreaMan(l1 = '') {
				let params = {};
				if (l1) {
					params.LEVEL1 = l1;
				}
				let {
					code,
					data
				} = await GetHelperAreaMan(params);

				if (code == 0) {
					this.FromArr[2].options = [];
					this.FromArr2[2].options = [];
					this.FromArr3[2].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr[2].options.push(obj);
						this.FromArr2[2].options.push(obj);
						this.FromArr3[2].options.push(obj);
					})
				}
			},
			//三级销售（地区）
			async getHelperRegionMan(str) {
				let {
					code,
					data
				} = await GetHelperRegionMan({
					ParentUserName: str
				});

				if (code == 0) {
					this.FromArr[3].options = [];
					this.FromArr2[3].options = [];
					this.FromArr3[3].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr[3].options.push(obj);
						this.FromArr2[3].options.push(obj);
						this.FromArr3[3].options.push(obj);
					})
				}
			},
			//销售代表
			async getHelperSalesMan(str) {
				let {
					code,
					data
				} = await GetHelperSalesMan({
					ParentUserName: str
				});

				if (code == 0) {
					this.FromArr3[4].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value
						}
						this.FromArr3[4].options.push(obj);
					})
				}
			},
			//省份
			async getProvinceSalesAmount() {
				let {
					code,
					data
				} = await GetProvinceSalesAmount({});

				if (code == 0) {
					this.FromArr[4].options = [{
						key: '不限',
						value: ''
					}];
					this.FromArr2[4].options = [{
						key: '不限',
						value: ''
					}];
					this.FromArr3[5].options = [{
						key: '不限',
						value: ''
					}];
					data.data.map((item, index) => {
						let obj = {
							key: item.Name,
							value: item.Name
						}
						this.FromArr[4].options.push(obj);
						this.FromArr2[4].options.push(obj);
						this.FromArr3[5].options.push(obj);
					})
				}
			},
			//经销商列表
			async getCustomerList(CusName = '') {
				let {
					code,
					data
				} = await GetCustomerList({
					CusName: CusName,
					pageIndex: 1,
					pageSize: 9999
				})
				if (code == 0) {
					this.FromArr[5].options = []
					data.data.map((item, index) => {
						let obj = {
							label: item.CusName,
							value: item.CusCode
						}
						this.FromArr[5].options.push(obj)
					})
				}
			},
			//经销商列表
			async getCustomerList2(CusName = '') {
				let {
					code,
					data
				} = await GetCustomerList({
					CusName: CusName,
					pageIndex: 1,
					pageSize: 9999
				})
				if (code == 0) {
					this.FromArr2[5].options = []
					data.data.map((item, index) => {
						let obj = {
							label: item.CusName,
							value: item.CusCode
						}
						this.FromArr2[5].options.push(obj)
					})
				}
			},
			//经销商列表
			async getCustomerList3(CusName = '') {
				let {
					code,
					data
				} = await GetCustomerList({
					CusName: CusName,
					pageIndex: 1,
					pageSize: 9999
				})
				if (code == 0) {
					this.FromArr3[6].options = []
					data.data.map((item, index) => {
						let obj = {
							label: item.CusName,
							value: item.CusCode
						}
						this.FromArr3[6].options.push(obj)
					})
				}
			},
			handReset(e = '') {
				if (e == '2') {
					this.FromArr2.map((item, index) => {
						item.modelvalue = '';
					})
					this.query2 = {};
					this.getSMSReportCustomerBusinessAmount();
				} else if (e == '3') {
					this.FromArr3.map((item, index) => {
						item.modelvalue = '';
					})
					this.query3 = {};
					this.getSMSReportCustomerBusinessTendency();
				} else if (e == '4') {
					this.FromArr4.map((item, index) => {
						item.modelvalue = '';
					})
					this.query4 = {};
					this.getInnerQuotaDetail();
				} else {
					this.FromArr.map((item, index) => {
						item.modelvalue = '';
						item.StartTime = '';
						item.EndTime = '';
					})
					this.query = {};
					this.getSMSReportCustomerBusinessSummary();
				}
			},
			handSearch(e = '') {
				if (e == '2') {
					this.query2.LEVEL1 = this.FromArr2[0].modelvalue;
					this.query2.LEVEL3 = this.FromArr2[1].modelvalue ? this.FromArr2[1].modelvalue.join(',') : '';
					this.query2.AreaMan = this.FromArr2[2].modelvalue ? this.FromArr2[2].modelvalue.join(',') : '';
					this.query2.RegionMan = this.FromArr2[3].modelvalue ? this.FromArr2[3].modelvalue.join(',') : '';
					this.query2.ProvinceName = this.FromArr2[4].modelvalue;
					this.query2.CusCode = this.FromArr2[5].modelvalue ? this.FromArr2[5].modelvalue.join(',') : '';
					this.getSMSReportCustomerBusinessAmount();
				} else if (e == '3') {
					this.query3.LEVEL1 = this.FromArr3[0].modelvalue;
					this.query3.LEVEL3 = this.FromArr3[1].modelvalue ? this.FromArr3[1].modelvalue.join(',') : '';
					this.query3.AreaMan = this.FromArr3[2].modelvalue ? this.FromArr3[2].modelvalue.join(',') : '';
					this.query3.RegionMan = this.FromArr3[3].modelvalue ? this.FromArr3[3].modelvalue.join(',') :
						'';
					this.query3.SalesMan = this.FromArr3[4].modelvalue ? this.FromArr3[4].modelvalue.join(',') :
						'';
					this.query3.ProvinceName = this.FromArr3[5].modelvalue;
					this.query3.CusCode = this.FromArr3[6].modelvalue ? this.FromArr3[6].modelvalue.join(',') : '';
					this.getSMSReportCustomerBusinessTendency();
				} else if (e == '4') {
					this.query4.Year = this.FromArr4[0].modelvalue;
					this.query4.InvClass = this.FromArr4[1].modelvalue;
					this.query4.LEVEL3 = this.FromArr4[2].modelvalue ? this.FromArr4[2].modelvalue.join(',') : '';
					this.query4.StartMonth = this.FromArr4[3].StartTime ? this.FromArr4[3].StartTime : '';
					this.query4.EndMonth = this.FromArr4[3].EndTime ? this.FromArr4[3].EndTime : '';
					this.getInnerQuotaDetail();
				} else {
					this.query.LEVEL1 = this.FromArr[0].modelvalue;
					this.query.StartDate = this.FromArr[1].StartTime;
					this.query.EndDate = this.FromArr[1].EndTime;
					this.query.AreaMan = this.FromArr[2].modelvalue ? this.FromArr[2].modelvalue.join(',') : '';
					this.query.RegionMan = this.FromArr[3].modelvalue ? this.FromArr[3].modelvalue.join(',') : '';
					this.query.ProvinceName = this.FromArr[4].modelvalue;
					this.query.CusCode = this.FromArr[5].modelvalue ? this.FromArr[5].modelvalue.join(',') : '';
					this.getSMSReportCustomerBusinessSummary();
				}
			},

			switchChange(e, k) {
				this[k + 'Index'] = e;
				if (k === 'year') {
					this.getSMSReportCustomerBusinessAmount();
				}
				if (k === 'l3' || k === 'sj') {
					this.getSMSReportCustomerBusinessTendency();
				}
			},
			//省份排名
			async getInnerQuotaDetail() {
				let {
					code,
					data
				} = await ProvinceASNRanking(this.query4)
				if (code == 0) {
					this.dataInfo4 = data;
				}
			},
			//FromArr 下拉框触发事件
			selectChange(e) {
				switch (e) {
					case 0:
						this.getHelperLevel3(this.FromArr3[0].modelvalue === '不限' ? '' : this.FromArr3[0]
							.modelvalue);
						this.getHelperAreaMan(this.FromArr3[0].modelvalue === '不限' ? '' : this.FromArr3[0]
							.modelvalue)
						break;
					case 1:
						break;
					case 2:
						this.getHelperRegionMan(this.FromArr3[2].modelvalue.join(','));
						break;
				}
			},
			//FromArr2 下拉框触发事件
			selectChange2(e) {
				switch (e) {
					case 0:
						this.getHelperLevel3(this.FromArr3[0].modelvalue === '不限' ? '' : this.FromArr3[0]
							.modelvalue);
						this.getHelperAreaMan(this.FromArr3[0].modelvalue === '不限' ? '' : this.FromArr3[0]
							.modelvalue)
						break;
					case 1:
						break;
					case 2:
						this.getHelperRegionMan(this.FromArr3[2].modelvalue.join(','));
						break;
				}
			},
			//FromArr3 下拉框触发事件
			selectChange3(e) {
				switch (e) {
					case 0:
						this.getHelperLevel3(this.FromArr3[0].modelvalue === '不限' ? '' : this.FromArr3[0]
							.modelvalue);
						this.getHelperAreaMan(this.FromArr3[0].modelvalue === '不限' ? '' : this.FromArr3[0]
							.modelvalue)
						break;
					case 1:
						break;
					case 2:
						this.getHelperRegionMan(this.FromArr3[2].modelvalue.join(','));
						break;
					case 3:
						this.getHelperSalesMan(this.FromArr3[3].modelvalue.join(','));
						break;
					case 4:
						break;
				}
			},
			parseStr(str, key) { //金钱格式化
				if (str) {
					if (key == 'MoneyQuota' || key == 'YearSales') {
						str = str.toFixed(0).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
					} else if (key.includes('Quarter') || key.includes('YearRatio')) {
						str = str.toFixed(1).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
					}
				} else {
					str = 0;
				}
				return str;
			}
		}
	}
</script>

<style lang="less" scoped>
	.channel-bussi {
		padding-bottom: 200px;

		.view-row {
			display: flex;
		}

		.view-search {
			height: 88px;
			margin: 16px 0px 16px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #E5E5E5;

			.search-title {
				font-size: 16px;
				font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
				font-weight: 500;
				color: #1D2129;
				position: absolute;
				top: 16px;
				left: 16px;
			}

			.view-switch {
				border-radius: 2px;
				overflow: hidden;
				display: flex;
				cursor: pointer;
				position: absolute;
				top: 16px;
				right: 16px;

				.switch-item {
					width: 54px;
					height: 28px;
					line-height: 28px;
					text-align: center;
					background: #FFFFFF;
					box-sizing: border-box;
					border: 1px solid #E5E6EB;
					font-size: 14px;
					font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
					font-weight: 400;
					color: #4E5969;
				}

				.switch-item:first-child {
					border-radius: 2px 0px 0px 2px;
					border-right: 0px;
				}

				.switch-item:last-child {
					border-radius: 0px 2px 2px 0px;
					border-left: 0px;
				}

				.current {
					border: 1px solid #BF0030;
					background: #BF0030;
					color: #FFFFFF;
				}

				.current2 {
					border: 1px solid #00266D;
					background: #00266D;
					color: #FFFFFF;
				}
			}


			.btngroup {
				float: none;
				//margin-left: 24px;
				margin-top: 0px;
			}
		}

		.view-table {
			margin: 24px;
			padding-bottom: 24px;

			/deep/.el-table {

				.el-table__body-wrapper::-webkit-scrollbar {
					width: 6px;
					height: 6px;
					background-color: white;
					cursor: pointer;
					border-radius: 12px;
				}

				// /*定义滑块 内阴影+圆角*/
				.el-table__body-wrapper::-webkit-scrollbar-thumb {
					box-shadow: inset 0 0 0px white;
					-webkit-box-shadow: inset 0 0 0px white;
					background-color: #D9D9D9;
					border-radius: 12px;
					cursor: pointer;
				}
			}
		}

		.view-switch-list {
			display: flex;
			align-items: center;
			justify-content: center;

			.view-switch {
				overflow: hidden;
				display: flex;
				cursor: pointer;

				.switch-item-red {
					width: 80px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
					font-weight: 400;
					color: #E71D43;
					background: url('../../../../assets/report/btn-red.png') no-repeat;
					background-size: 100% 100%;
					margin: 0px 8px;
				}

				.switch-item-blue {
					width: 80px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
					font-weight: 400;
					color: #00266D;
					background: url('../../../../assets/report/btn-blue.png') no-repeat;
					background-size: 100% 100%;
					margin: 0px 8px;
				}

				.current-red {
					background: url('../../../../assets/report/btn-red-checked.png') no-repeat;
					background-size: 100% 100%;
					color: #FFFFFF;
				}

				.current-blue {
					background: url('../../../../assets/report/btn-blue-checked.png') no-repeat;
					background-size: 100% 100%;
					color: #FFFFFF;
				}
			}
		}

		.merge {
			min-height: 88px;
			padding-bottom: 22px;
			position: relative;
			margin-bottom: 0px;
			align-items: flex-end;
		}

		.content-view {
			background: #FFFFFF;
			margin-top: 16rpx;
			position: relative;
		}
	}

	.view-amount {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		padding: 12px;


		.amount-label {
			font-size: 16px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #333333;
		}

		.amount-value {
			font-size: 32px;
			font-family: D-DIN-Bold, D-DIN;
			font-weight: 700;
			line-height: 40px;
			letter-spacing: 5px;
			//text-shadow: 0px 2px 8px rgba(27, 126, 242, 0.32);
			background: linear-gradient(180deg, rgba(27, 126, 242, 0.48) 0%, #1B7EF2 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			margin: 0px 10px;
		}

		.amount-unit {
			font-size: 14px;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
		}
	}
</style>